import React from 'react';
import Layout from '../../components/layout';
import SchoolsComponent from '../../components/facilitators/schools';

const headerText = 'FACILITATORS';

const Schools = () => {
  return (
    <Layout headerText={headerText} heroBg="grass">
      <SchoolsComponent />
    </Layout>
  );
};

export default Schools;
